import React from "react";
// import LoginPage from "./component/login/login";
import RegisterPage from "./component/login/RegisterPage";
import Dashboard from "./component/dashboard/Dashboard";
import CallPage from "./component/dashboard/CallPage";
import { BrowserRouter as Router, Routes, Route ,Navigate } from "react-router-dom";
import PrivateRoute from "./component/PrivateRoute";
import LoginPage from "./component/login/LoginPage";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ExecutiveDashboard from "./component/ExecutiveDashboard/ExecutiveDashboard";
import AdminDashboard from "./component/AdminDashboard/AdminDashboard";

const App = () => {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage></LoginPage>} />
          <Route path="/admin/reg" element={<RegisterPage />} />

          <Route path="/executive-dashboard" element={<PrivateRoute> <ExecutiveDashboard></ExecutiveDashboard></PrivateRoute> } />

          <Route path="/admin-dashboard" element={<PrivateRoute><AdminDashboard></AdminDashboard> </PrivateRoute>   } />

          <Route path="/dashboard" element={<PrivateRoute> <Dashboard /></PrivateRoute>}  />
          <Route
            path="/call/:name/:number"
            element={<CallPage />}
          />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>

      
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default App;